import {Injectable} from '@angular/core';
import {HubConnection, HubConnectionBuilder} from '@microsoft/signalr';
import {AuthService} from './user-services/auth.service';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SignalrService {
  private hubConnection: HubConnection;

  constructor(private authService: AuthService) { }

  public startConnection = () => {
    this.hubConnection = new HubConnectionBuilder()
      .withUrl(`${environment.identityUrl}/notifications`,
        { accessTokenFactory: () => this.authService.getAccessToken() })
      .withAutomaticReconnect()
      .build();
    this.hubConnection
      .start()
      .then()
      .catch(error => console.log('Error while starting connection', error));
  }

  public stopConnection = () => {
    this.hubConnection
      .stop()
      .then()
      .catch(error => console.log('Error while stopping connection', error));
  }

  public addRevokeSessionListener = () => {
    this.hubConnection.on('revokeSession', () => {
      this.authService
        .logout()
        .then(() => {
          this.stopConnection();
          window.localStorage.setItem('revoked', 'true');
        });
    });
  }
}
